import { Box } from '@mui/material';
import { IBeneficiary } from '@smiles/voebiz-core-beneficiaries/dist/Types/BeneficiaryByDocumentApi.types';
import { Button, VbzInputText } from '@smiles/voebiz-ui-kit';
import dayjs, { Dayjs } from 'dayjs';
import React, { useState } from 'react';
import 'react-dates/lib/css/_datepicker.css';
import { useTranslation } from 'react-i18next';
import { updateBeneficiary } from 'services/services';
import { cpfMask } from 'utils/maskCpf';
import CalendarMui from '../CalendarMui/index';
import DrawerModal from '../DrawerModal';
import WarningIcon from '../Icons/WarningIcon';

interface Props {
  isOpen: boolean;
  closeModal(): void;
  beneficiaryDetails: IBeneficiary;
}

function ResponseSummaryModal(props: Props) {
  const { isOpen, closeModal, beneficiaryDetails } = props;

  const { t } = useTranslation(['summary', 'reactivateBeneficiary']);

  const [fullname, setName] = useState(beneficiaryDetails.fullname);

  const [loading, setLoading] = useState(false);

  const [email, setEmail] = useState(beneficiaryDetails.email);

  const [cpf] = useState(beneficiaryDetails.cpf);

  const birthdayFormated = new Date(beneficiaryDetails.birthdate);

  const [birthday, setBirthday] = useState<Dayjs>(dayjs(birthdayFormated));

  const handleSubmit = async () => {
    setLoading(true);

    const payload = {
      name: fullname,
      email,
      document: cpf,
      birthdate: birthday.format('MM/DD/YYYY'),
      status: beneficiaryDetails.status,
    };

    const response = updateBeneficiary(payload);

    if (response) {
      response.then(() => closeModal()).finally(() => setLoading(false));
    }
  };

  const IsValidateEmail = /^[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\.[A-Za-z]{2,}$/.test(email);

  const isValidateName = /^[A-Za-z]+ [A-Za-z]+/.test(fullname);

  const isDisabledButton = !(isValidateName && IsValidateEmail) || loading;

  const cpfMasked = cpfMask(cpf ?? '00000000000');

  return (
    <DrawerModal id="summary-benefits" open={isOpen} anchor="right" onClose={() => closeModal()}>
      <Box className="form-summary">
        <h5>{t('title_modal')}</h5>

        <div className="name-summary">
          <VbzInputText
            alt="input-nome-completo"
            forceError={!isValidateName}
            textLabel={t('full_name')}
            value={fullname}
            onChange={(e) => setName(e.target.value)}
            autoComplete="off"
            autoFocus
            errorMessage="Informe pelo menos 2 palavras."
          />
        </div>

        <div className="cpf-summary">
          <VbzInputText
            alt="input-cpf"
            textLabel={t('cpf_member')}
            autoComplete="off"
            disabled
            placeholder={cpfMasked}
          />
        </div>

        <div className="email-summary">
          <VbzInputText
            alt="input-email"
            forceError={!IsValidateEmail}
            textLabel={t('email_member')}
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            autoComplete="off"
            errorMessage="Informe um e-mail válido."
          />
        </div>

        <div className="calendar-summary">
          <p>{t('birthday_member')}</p>
          <CalendarMui
            label=""
            views={['day', 'month', 'year']}
            format="DD/MM/YYYY"
            value={dayjs(birthday)}
            onChange={(val) => {
              if (val) setBirthday(val);
            }}
          />
        </div>

        <div className="text-summary">
          <div className="warning">
            <div className="warning-summary">
              <WarningIcon />
              <b className="text-warning-summary">{t('warning_modal_title')}</b>
            </div>
            <p>{t('warning_modal_description')}</p>
          </div>
        </div>
        <div className="new-button">
          <Button
            htmlType="button"
            id="button-summary-modal"
            onClick={handleSubmit}
            className="button-summary-modal"
            disabled={isDisabledButton}
          >
            <span className="undefined">{t('button_save')}</span>
          </Button>
        </div>
      </Box>
    </DrawerModal>
  );
}

export default ResponseSummaryModal;
